import styled, { DefaultTheme } from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export type V3ProgressBarTone = "brand" | "positive" | "warning";

const FILL: Record<V3ProgressBarTone, (theme: DefaultTheme) => string> = {
  brand: (theme) => theme.colors.ui.interactive.primary,
  positive: (theme) =>
    theme.mode === "dark"
      ? theme.colors.ui.background.gain
      : theme.colors.ui.feedback.gaugeFill,
  warning: (theme) => theme.colors.ui.feedback.warning,
};

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StepperTrack = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: ${({ theme }) => theme.space["2xs"]}px;
`;

export const StepperSegment = styled.span<{ $filled: boolean }>`
  flex: 1 1 0;
  height: ${({ theme }) => theme.size.indicator["progress-bar"].thickness}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme, $filled }) =>
    $filled
      ? theme.colors.ui.interactive.primary
      : theme.colors.ui.background.inset};
`;

export const StepperCounter = styled.span`
  ${typographyCSS("caption.sm")}
  flex: none;
  white-space: nowrap;
  margin-left: ${({ theme }) => theme.space.md}px;
  color: ${({ theme }) => theme.colors.ui.text.tertiary};
`;

export const BarTrack = styled.div`
  width: 100%;
  overflow: hidden;
  height: ${({ theme }) => theme.size.indicator["progress-bar"].thickness}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme }) => theme.colors.ui.background.inset};
`;

export const BarFill = styled.div<{ $tone: V3ProgressBarTone }>`
  height: 100%;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme, $tone }) => FILL[$tone](theme)};
`;
